import React, { useRef, useState, useEffect } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { useGLTF, ContactShadows, Environment, OrbitControls } from "@react-three/drei";
import { HexColorInput, HexColorPicker } from "react-colorful";
import { proxy, useSnapshot } from "valtio";
import {BsWhatsapp} from 'react-icons/bs'

function isDarkColor(hexColor = "") {
  hexColor = hexColor.replace(/^#/, ''); // Remove any leading "#"

  const r = parseInt(hexColor.substring(0, 2), 16);
  const g = parseInt(hexColor.substring(2, 4), 16);
  const b = parseInt(hexColor.substring(4, 6), 16);

  const brightness = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return brightness >= 0.6; // Use white background for dark colors, and vice versa
}





function getAdjustedBackgroundColor(hexColor='') {
  // Remove any leading "#" if present
  hexColor = hexColor.replace(/^#/, '');

  // Convert the hex color to RGB
  const r = parseInt(hexColor.substring(0, 2), 16);
  const g = parseInt(hexColor.substring(2, 4), 16);
  const b = parseInt(hexColor.substring(4, 6), 16);

  // Calculate the brightness using the formula (0.299*R + 0.587*G + 0.114*B)
  const brightness = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Define a threshold for considering a color as "light"
  const lightnessThreshold = 0.8;
  const fixThreshold=30;

  // If the color is considered light, return a slightly darker color
  if (brightness > lightnessThreshold) {
    // Calculate the adjusted color by reducing each RGB component
    const adjustedR = Math.max(0, r - fixThreshold);
    const adjustedG = Math.max(0, g - fixThreshold);
    const adjustedB = Math.max(0, b - fixThreshold);

    // Convert the adjusted RGB components back to hex
    const adjustedHexColor = `#${adjustedR.toString(16).padStart(2, '0')}${adjustedG.toString(16).padStart(2, '0')}${adjustedB.toString(16).padStart(2, '0')}`;

    return adjustedHexColor;
  }

  // If the color is not considered light, return the original color
  return `#${hexColor}`;
}


const state = proxy({
  name:"shoes",
  current: null,
  items: {
    laces: {
      color: "#fff",
      presets:  ["#000000", "#FF33A6", "#d6ff33","#33ffd6","#FF8383"],
    },
    mesh: {
      color: "#fff",
      presets: ["#000000", "#FF33A6", "#d6ff33","#33ffd6","#FF8383"],
    },
    caps: {
      color: "#fff",
      presets:  ["#000000", "#FF33A6", "#d6ff33","#33ffd6","#FF8383"],
    },
    inner: {
      color: "#fff",
      presets: ["#000000", "#FF33A6", "#d6ff33","#33ffd6","#FF8383"],
    },
    sole: {
      color: "#fff",
      presets:  [ "#d6ff33","#33ffd6","#FF8383"],
    },
    stripes: {
      color: "#fff",
      presets:  ["#000000", "#FF33A6", "#d6ff33","#33ffd6","#FF8383"],
    },
    band: {
      color: "#fff",
      presets:  ["#000000", "#FF33A6", "#d6ff33","#33ffd6","#FF8383"],
    },
    patch: {
      color: "#fff",
      presets:  ["#000000", "#FF33A6", "#d6ff33","#33ffd6","#FF8383"],
    },
  },
});


function generateWhatsAppMessage() {

  const items=state.items 
  
  const phoneNumber='96171731901'

  // Create a message with item specifications
  let message = `Hello, I want to order these *${state.name}* from *moondev.solutions*:\n-------------\nSpecs:\n`;
  
  for (const itemName in items) {
    const item = items[itemName];
    message += `   *${itemName}*: ${item.color}\n`;
  }

  // Encode the message for a URL
  const encodedMessage = encodeURIComponent(message);


  // Open WhatsApp Web with the message to the specified phone number
  window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`);

  // You can also focus the new window if needed
  // newWindow.focus();
}

function Shoe() {
  const ref = useRef();
  const snap = useSnapshot(state);
  const { nodes, materials } = useGLTF("shoe-draco.glb");
  const [hovered, set] = useState(null);
  console.log('nodes shoe ',nodes,'materials',materials)
  useFrame((state) => {
    const t = state.clock.getElapsedTime();
    ref.current.rotation.set(Math.cos(t / 4) / 8, Math.sin(t / 4) / 8, -0.2 - (1 + Math.sin(t / 1.5)) / 20);
    ref.current.position.y = (1 + Math.sin(t / 1.5)) / 10;
  });

  useEffect(() => {
    const cursor = `<svg width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path fill="rgba(255, 255, 255, 0.5)" d="M29.5 54C43.031 54 54 43.031 54 29.5S43.031 5 29.5 5 5 15.969 5 29.5 15.969 54 29.5 54z" stroke="#000"/><g filter="url(#filter0_d)"><path d="M29.5 47C39.165 47 47 39.165 47 29.5S39.165 12 29.5 12 12 19.835 12 29.5 19.835 47 29.5 47z" fill="${snap.items[hovered]?.color}"/></g><path d="M2 2l11 2.947L4.947 13 2 2z" fill="#000"/><text fill="#000" style="#fff-space:pre" font-family="Inter var, sans-serif" font-size="10" letter-spacing="-.01em"><tspan x="35" y="63">${hovered}</tspan></text></g><defs><clipPath id="clip0"><path fill="#fff" d="M0 0h64v64H0z"/></clipPath><filter id="filter0_d" x="6" y="8" width="47" height="47" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="2"/><feGaussianBlur stdDeviation="3"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>`;
    const auto = `<svg width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="rgba(255, 255, 255, 0.5)" d="M29.5 54C43.031 54 54 43.031 54 29.5S43.031 5 29.5 5 5 15.969 5 29.5 15.969 54 29.5 54z" stroke="#000"/><path d="M2 2l11 2.947L4.947 13 2 2z" fill="#000"/></svg>`;
    
    if (hovered) {
      document.body.style.cursor = `url('data:image/svg+xml;base64,${btoa(cursor)}'), auto`;
      return () => (document.body.style.cursor = `url('data:image/svg+xml;base64,${btoa(auto)}'), auto`);
    }
  }, [hovered]);

  return (
    <group
      ref={ref}
      onPointerOver={(e) => (e.stopPropagation(), set(e.object.material.name))}
      onPointerOut={(e) => e.intersections.length === 0 && set(null)}
      onPointerMissed={() => (state.current = null)}
      onClick={(e) => (e.stopPropagation(), (state.current = e.object.material.name))}>
      <mesh receiveShadow castShadow geometry={nodes.shoe.geometry} material={materials.laces} material-color={snap.items.laces.color} />
      <mesh receiveShadow castShadow geometry={nodes.shoe_1.geometry} material={materials.mesh} material-color={snap.items.mesh.color} />
      <mesh receiveShadow castShadow geometry={nodes.shoe_2.geometry} material={materials.caps} material-color={snap.items.caps.color} />
      <mesh receiveShadow castShadow geometry={nodes.shoe_3.geometry} material={materials.inner} material-color={snap.items.inner.color} />
      <mesh receiveShadow castShadow geometry={nodes.shoe_4.geometry} material={materials.sole} material-color={snap.items.sole.color} />
      <mesh
        receiveShadow
        castShadow
        geometry={nodes.shoe_5.geometry}
        material={materials.stripes}
        material-color={snap.items.stripes.color}
      />
      <mesh receiveShadow castShadow geometry={nodes.shoe_6.geometry} material={materials.band} material-color={snap.items.band.color} />
      <mesh receiveShadow castShadow geometry={nodes.shoe_7.geometry} material={materials.patch} material-color={snap.items.patch.color} />
    </group>
  );
}

function Picker() {
  const snap = useSnapshot(state);
  return (
    <div className="picker-container">
      <div className="picker">

  {   ! snap.items[snap.current]?.presets  
   ?
    <HexColorPicker
          className="hexpicker"
          color={snap.items[snap.current]?.color}
          onChange={(color) =>{
            state.items[snap.current] = {
              ...state.items[snap.current],
              color: color,
            };
          }}
        />
      :
        <div className="preset-picker">
          {snap.items[snap.current]?.presets.map((presetColor) => (
            <button
              key={presetColor}
              style={{ background: presetColor }}
              onClick={() => {
                state.items[snap.current] = {
                  ...state.items[snap.current],
                  color: presetColor,
                };
              }}
            />
          ))}
        </div>}

        <HexColorInput
          className="hexinput"
          style={{
            color: isDarkColor(snap.items[snap.current]?.color) ? "#272730" : "#fff",
            borderColor: isDarkColor(snap.items[snap.current]?.color) ? "#272730" : "#fff",
            
           

            background:snap.items[snap.current]?.color,
          }}
          color={snap.items[snap.current]?.color}
          onChange={(color) => {
            state.items[snap.current] = {
              ...state.items[snap.current],
              color: color,
            };
          }}
        />
      </div>

      {snap.current ? <h1>{snap.current}</h1> : <h3>Click👇 on shoe👟 to style it</h3>}
    </div>
  );
}

function App() {
  return (
    <div style={{ height: "100%", width: "100%", position: "relative" }}>
      <Canvas shadows camera={{ position: [0, 0, 4], fov: 45 }} background={"white"}>
        <ambientLight intensity={0.7} />
        <spotLight intensity={0.5} angle={0.1} penumbra={1} position={[10, 15, 10]} castShadow />
        <Shoe />
        <Environment preset="city" />
        <ContactShadows position={[0, -0.8, 0]} opacity={0.25} scale={10} blur={1.5} far={0.8} />
        <OrbitControls minPolarAngle={Math.PI / 2} maxPolarAngle={Math.PI / 2} enableZoom={true} enablePan={false} />
      </Canvas>
      <Picker />

      <button
        className="share"
        onClick={async () => {
      
          generateWhatsAppMessage()
          const link = document.createElement("a");
          const canvas = document.querySelector("canvas");

          await new Promise((resolve) => requestAnimationFrame(resolve));

          link.setAttribute("download", "my-styled-shoe.png");
          link.setAttribute("href", canvas.toDataURL("image/png").replace("image/png", "image/octet-stream"));
          link.click();
        }}>
       Save & Order Now <span><BsWhatsapp  size='25'/> </span>
      
      </button>
    </div>
  );
}

export default App;
